import request from '@/axios'

export const loginApi = (data): Promise<IResponse> => {
  return request.post({ url: '/operation/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/operation/logout' })
}

export const getAuthMenu = () => {
  return request.get({ url: '/operation/getAuthMenu' })
}
